import { FormattedMessage } from "react-intl";
import MyShotClassIcon from "../../../components/Common/SvgIcons/SocialIcons/MyShotClassIcon";
import PublishedIcon from "../../../components/Common/SvgIcons/SocialIcons/PublishedIcon";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../tableColumnTypes";
import { manage } from "../manage/manage";
import { moderateContributions } from "./moderateContributions";

export const published = {
  label: <FormattedMessage id="MYCLASS_PUBLISHED" />,
  path: (tenantName) => `${moderateContributions.path(tenantName)}/published`,
  icon: (fill) => <PublishedIcon fill={fill} />,
  searchPlaceHolder: "Search published moderate contents by name",
  columns: (tenantName) => [
    {
      ID: 1,
      name: <FormattedMessage id="REPORT_CLSNAME" />,
      fieldName: "Name",
      value: (row) => (
        <div title={row?.Name}>
          {row?.Name?.length > 25 ? row?.Name?.slice(0, 23) + "..." : row?.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="ContributorUserName_lbl" />,
      fieldName: "FirstName",
      value: (row) => row.FirstName + " " + row.LastName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="LastModifiedByDate_lbl" />,
      fieldName: "ModifiedDate",
      value: (row) => row.ModifiedDate,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 4,
      name: <FormattedMessage id="STATUS_TEXT" />,
      fieldName: "StatusText",
      value: (row) => row.StatusText,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="MyClassVideoUploadStatus_lbl" />,
      fieldName: "VideoUploadStatus",
      value: (row) =>
        row.VideoUploadStatus === 0 ? (
          <FormattedMessage id="VideoNotAvailable" />
        ) : row.VideoUploadStatus === 1 ? (
          <FormattedMessage id="ProcessingInProgress" />
        ) : row.VideoUploadStatus === 2 ? (
          <FormattedMessage id="ProcessingFailed" />
        ) : row.VideoUploadStatus === 3 ? (
          <FormattedMessage id="ProcessingSucceed" />
        ) : (
          ""
        ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 6,
      name: <FormattedMessage id="Cer_Actions" />,
      fieldName: "",
      value: () => (
        <span onClick={() => window.open(manage.path(tenantName))}>
          <Tooltip
            direction="bottom"
            content={<FormattedMessage id="SELECT_EVENTS" />}
          >
            <MyShotClassIcon />
          </Tooltip>
        </span>
      ),
      sort: false,
    },
  ],
};
